<template>
    <div class="profile-header">
        <div class="avatar-section">
            <div class="avatar-circle">
                {{ userInitials }}
            </div>
            <h1 class="profile-name">{{ userName }}</h1>
            <div class="tier-badge-large" :class="getTierClass(subscriptionTier)">
                {{ getTierDisplayName(subscriptionTier) }}
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { getTierDisplayName } from '@/config/tiers';

export default {
    name: 'ProfileHeader',
    props: {
        userName: {
            type: String,
            default: 'Student'
        },
        subscriptionTier: {
            type: String,
            default: 'FREE'
        }
    },
    setup(props) {
        const userInitials = computed(() => {
            if (!props.userName) return 'ST';
            const names = props.userName.split(' ');
            if (names.length === 1) return names[0].charAt(0).toUpperCase();
            return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
        });

        const getTierClass = (tier) => {
            const tierLower = tier.toLowerCase().replace(/\s+/g, '-');
            return `tier-${tierLower}`;
        };

        return {
            userInitials,
            getTierClass,
            getTierDisplayName
        };
    }
};
</script>

<style scoped>
.profile-header {
    text-align: center;
    margin-bottom: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(var(--accent-rgb), 0.6);
}

.avatar-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.avatar-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--accent) 0%, var(--text-primary) 100%);
    color: var(--bg-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    font-weight: 600;
}

.profile-name {
    font-size: 32px;
    color: var(--text-primary);
    margin: 0;
}

.tier-badge-large {
    padding: 12px 30px;
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
}

.tier-free {
    background: linear-gradient(135deg, rgba(150, 150, 150, 0.3) 0%, rgba(100, 100, 100, 0.3) 100%);
    color: #aaa;
    border: 1px solid rgba(150, 150, 150, 0.5);
}

.tier-tier-1 {
    background: linear-gradient(135deg, rgba(100, 200, 255, 0.3) 0%, rgba(50, 150, 255, 0.3) 100%);
    color: #64c8ff;
    border: 1px solid rgba(100, 200, 255, 0.5);
}

.tier-tier-2 {
    background: linear-gradient(135deg, rgba(147, 51, 234, 0.3) 0%, rgba(100, 30, 180, 0.3) 100%);
    color: #9333ea;
    border: 1px solid rgba(147, 51, 234, 0.5);
}

.tier-tier-3 {
    background: var(--bg-secondary);
    color: var(--accent);
    border: 1px solid var(--accent);
}
</style>
